var map = {
	"./10.png": 146,
	"./1009269.jpg": 147,
	"./1302261.jpg": 148,
	"./1323866.jpg": 149,
	"./angular.png": 78,
	"./code.png": 79,
	"./design-logo1.png": 80,
	"./design-logo2.png": 81,
	"./design-logo3.png": 82,
	"./design-logo4.png": 83,
	"./design-logo5.png": 150,
	"./dot.png": 45,
	"./dot_big.png": 84,
	"./html.png": 85,
	"./logo1.png": 151,
	"./logo2.png": 152,
	"./man.png": 86,
	"./mern.png": 87,
	"./polygon.png": 88,
	"./pr1.jpg": 89,
	"./pr2.jpg": 90,
	"./pr3.jpg": 46,
	"./react.png": 91,
	"./shap.png": 92,
	"./testimonial_bg_circle.png": 93,
	"./video_shap.png": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 422;